<template>
  <BaseModal :modal-name="name" max-width="max-w-2xl" @closed="onCancel">
    <p class="mb-10 text-2xl font-medium text-darkestGray">
      Edytuj dane Pacjenta
    </p>

    <PatientsEditForm
      ref="patientEditForm"
      :init-patient="cartStore.selectedPatient"
    />

    <div
      class="mt-4 flex items-center justify-center space-x-8 text-sm md:justify-end"
    >
      <BaseButton
        theme="link"
        size="lg"
        class="text-primary hover:underline hover:brightness-50"
        @click="onCancel"
      >
        {{ $t('action.cancel') }}
      </BaseButton>

      <BaseButton theme="primary" size="lg" @click="onClickConfirm">
        {{ $t('action.confirm') }}
      </BaseButton>
    </div>
  </BaseModal>
</template>

<script setup>
import { useCartStore } from '~~/stores/cart'
import { useModalsStore } from '~~/stores/modals'

const name = 'editPatientModal'

const cartStore = useCartStore()
const modalsStore = useModalsStore()

const patientEditForm = ref()

const onClickConfirm = async () => {
  const isSubmitted = await patientEditForm.value.submit()

  if (isSubmitted) {
    modalsStore.close(name)
  }
}

const onCancel = () => {
  modalsStore.close(name)
}
</script>
